import { render, staticRenderFns } from "./detail-dialog.vue?vue&type=template&id=2c274f08&scoped=true&"
import script from "./detail-dialog.vue?vue&type=script&lang=js&"
export * from "./detail-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c274f08",
  null
  
)

export default component.exports